import { useEffect } from 'react';
import { EventObject, Interpreter, StateSchema } from 'xstate';

import webView from 'common/webView';
import { logEvent } from 'features/Analytics/analytics';

export enum CompanyType {
  MICRO = 'micro',
  NONMICRO = 'non-micro',
}

export const useTrackMachine = <TContext, TEvent extends EventObject>(
  // Using any because it seems that's the default for useMachine as well
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  service: Interpreter<TContext, StateSchema<any>, TEvent>,
) => {
  useEffect(() => {
    service.onTransition((state) => {
      if (state.changed) {
        logEvent({
          name: `${webView.isInWebView ? 'Mobile' : 'Web'} Tax Estimation Step`,
          properties: {
            step: state.value,
            type: CompanyType.MICRO,
          },
          usePrefix: false,
        });
      }
    });
  }, [service]);
};
